import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var te = Object.defineProperty,
    Te = Object.defineProperties;
var Be = Object.getOwnPropertyDescriptors;
var Q = Object.getOwnPropertySymbols;
var Ve = Object.prototype.hasOwnProperty,
    Ae = Object.prototype.propertyIsEnumerable;

var ee = function ee(e, o, r) {
  return o in e ? te(e, o, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : e[o] = r;
},
    re = function re(e, o) {
  for (var r in o || (o = {})) {
    Ve.call(o, r) && ee(e, r, o[r]);
  }

  if (Q) {
    var _iterator = _createForOfIteratorHelper(Q(o)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var r = _step.value;
        Ae.call(o, r) && ee(e, r, o[r]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return e;
},
    oe = function oe(e, o) {
  return Te(e, Be(o));
};

var De = function De(e, o) {
  for (var r in o) {
    te(e, r, {
      get: o[r],
      enumerable: !0
    });
  }
};

import { assignInlineVars as Ge } from "@vanilla-extract/dynamic";
import se, { createContext as We, useContext as je } from "react";
var F = {};
De(F, {
  android: function android() {
    return He;
  },
  cupertino: function cupertino() {
    return Oe;
  },
  globalVars: function globalVars() {
    return i;
  },
  rootAndroid: function rootAndroid() {
    return Fe;
  },
  rootCupertino: function rootCupertino() {
    return $e;
  }
});
var He = "_1coppmz0",
    Oe = "_1coppmz1",
    i = {
  backgroundColor: "var(--stackflow-plugin-basic-ui-background-color)",
  dimBackgroundColor: "var(--stackflow-plugin-basic-ui-dim-background-color)",
  appBar: {
    borderColor: "var(--stackflow-plugin-basic-ui-app-bar-border-color)",
    borderSize: "var(--stackflow-plugin-basic-ui-app-bar-border-size)",
    height: "var(--stackflow-plugin-basic-ui-app-bar-height)",
    iconColor: "var(--stackflow-plugin-basic-ui-app-bar-icon-color)",
    textColor: "var(--stackflow-plugin-basic-ui-app-bar-text-color)",
    backgroundColor: "var(--stackflow-plugin-basic-ui-app-bar-background-color)"
  },
  bottomSheet: {
    borderRadius: "var(--stackflow-plugin-basic-ui-bottom-sheet-border-radius)"
  },
  modal: {
    borderRadius: "var(--stackflow-plugin-basic-ui-bottom-sheet-border-radius)"
  }
},
    Fe = ":root[data-stackflow-plugin-basic-ui-theme=android]",
    $e = ":root[data-stackflow-plugin-basic-ui-theme=cupertino]";

function R(e) {
  return Object.entries(e).reduce(function (o, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        r = _ref2[0],
        t = _ref2[1];

    return t != null && (o[r] = t), o;
  }, {});
}

function T(e, o, r) {
  var t = function t() {
    e.removeEventListener(o, t), r();
  };

  e.addEventListener(o, t);
}

var ae = function ae(e) {
  return e(), window.addEventListener("resize", e), function () {
    window.removeEventListener("resize", e);
  };
};

var ne = function ne() {};

function B(e) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      e();
    });
  });
}

var ie = We({
  theme: "android"
}),
    Xe = ie.Provider;

function V() {
  return je(ie);
}

var Ue = function Ue(e) {
  return function () {
    return {
      key: "basic-ui",
      wrapStack: function wrapStack(_ref3) {
        var _R;

        var o = _ref3.stack;
        var r, t, a, n, c, l, s;
        return se.createElement(Xe, {
          value: e
        }, se.createElement("div", {
          className: typeof window != "undefined" ? F[e.theme] : void 0,
          style: Ge(R((_R = {}, _defineProperty(_R, i.backgroundColor, e.backgroundColor), _defineProperty(_R, i.dimBackgroundColor, e.dimBackgroundColor), _defineProperty(_R, i.appBar.borderColor, (r = e.appBar) == null ? void 0 : r.borderColor), _defineProperty(_R, i.appBar.borderSize, (t = e.appBar) == null ? void 0 : t.borderSize), _defineProperty(_R, i.appBar.height, (a = e.appBar) == null ? void 0 : a.height), _defineProperty(_R, i.appBar.iconColor, (n = e.appBar) == null ? void 0 : n.iconColor), _defineProperty(_R, i.appBar.textColor, (c = e.appBar) == null ? void 0 : c.textColor), _defineProperty(_R, i.bottomSheet.borderRadius, (l = e.bottomSheet) == null ? void 0 : l.borderRadius), _defineProperty(_R, i.modal.borderRadius, (s = e.modal) == null ? void 0 : s.borderRadius), _R)))
        }, o.render()));
      }
    };
  };
};

import { useActions as lt, useActivity as dt } from "@stackflow/react";
import { assignInlineVars as pt } from "@vanilla-extract/dynamic";
import w, { useRef as P } from "react";
import { useEffect as Ye, useState as Ze } from "react";

function L(e) {
  var _Ze = Ze(void 0),
      _Ze2 = _slicedToArray(_Ze, 2),
      o = _Ze2[0],
      r = _Ze2[1];

  return Ye(function () {
    B(function () {
      r(e);
    });
  }, [e]), o;
}

import { useEffect as Je, useState as Ke } from "react";

function ce(_ref4) {
  var e = _ref4.outerRef,
      o = _ref4.innerRef,
      r = _ref4.enable;

  var _Ke = Ke(void 0),
      _Ke2 = _slicedToArray(_Ke, 2),
      t = _Ke2[0],
      a = _Ke2[1];

  return Je(function () {
    var n = e && "current" in e && e.current,
        c = o.current;
    return !r || !n || !c ? ne : ae(function () {
      var s = n.clientWidth,
          d = c.offsetLeft,
          f = c.clientWidth,
          y = s - d - f,
          u = Math.max(d, y);
      a(s - 2 * u);
    });
  }, []), {
    maxWidth: t
  };
}

import { useActivity as Qe } from "@stackflow/react";
import { useEffect as le } from "react";
var M = {};

function C(_ref5) {
  var e = _ref5.styleName,
      o = _ref5.refs,
      r = _ref5.effect;
  var t = Qe();
  le(function () {
    return M[e] || (M[e] = new Map()), M[e].set(t.zIndex, {
      refs: o,
      hasEffect: !!r
    }), function () {
      M[e].delete(t.zIndex);
    };
  }, [t.id, o, r]), le(function () {
    if (!r) return function () {};

    var a = function () {
      var c = [];

      for (var l = 1; l <= t.zIndex; l += 1) {
        var s = M[e].get(t.zIndex - l);
        if (s != null && s.refs && (c = [].concat(_toConsumableArray(c), _toConsumableArray(s.refs))), s != null && s.hasEffect) break;
      }

      return c;
    }(),
        n = r({
      activityTransitionState: t.transitionState,
      refs: a
    });

    return function () {
      n == null || n();
    };
  }, [t.transitionState]);
}

function de(_ref6) {
  var e = _ref6.refs,
      o = _ref6.hasEffect;
  C({
    styleName: "hide",
    refs: e,
    effect: o ? function (_ref7) {
      var r = _ref7.activityTransitionState,
          t = _ref7.refs;

      switch (r) {
        case "enter-done":
          {
            t.forEach(function (a) {
              !a.current || (a.current.style.display = "none");
            });
            break;
          }

        default:
          {
            t.forEach(function (a) {
              !a.current || (a.current.style.display = "");
            });
            break;
          }
      }
    } : void 0
  });
}

var et = 32,
    A = 80;

function pe(_ref8) {
  var e = _ref8.refs,
      o = _ref8.theme,
      r = _ref8.hasEffect;
  C({
    styleName: "offset",
    refs: e,
    effect: r ? function (_ref9) {
      var t = _ref9.activityTransitionState,
          a = _ref9.refs;
      var n = o === "cupertino" ? "translateX(-".concat(A / 16, "rem)") : "translateY(-".concat(et / 16, "rem)");

      switch (t) {
        case "enter-active":
        case "enter-done":
          {
            a.forEach(function (c) {
              !c.current || (c.current.style.transition = "var(--stackflow-transition-duration)", c.current.style.transform = n);
            });
            break;
          }

        case "exit-active":
        case "exit-done":
          {
            B(function () {
              a.forEach(function (c) {
                if (!c.current) return;
                var l = c.current;
                l.style.transform = "", T(l, "transitionend", function () {
                  l.style.transition = "";
                });
              });
            });
            break;
          }

        default:
          break;
      }
    } : void 0
  });
}

function me(_ref10) {
  var e = _ref10.theme,
      o = _ref10.dimRef,
      r = _ref10.edgeRef,
      t = _ref10.paperRef,
      a = _ref10.hasEffect,
      n = _ref10.onSwiped;
  C({
    styleName: "swipe-back",
    refs: [t],
    effect: a ? function (_ref11) {
      var c = _ref11.refs;
      if (e !== "cupertino") return function () {};
      if (!o.current || !r.current || !t.current) return function () {};

      var l = o.current,
          s = r.current,
          d = t.current,
          f = null,
          y = null,
          u = null,
          g = [],
          m = function m() {
        f = null, y = null, u = null, g = [];
      },
          q = !1;

      function z(v) {
        q || (q = !0, requestAnimationFrame(function () {
          var p = v / d.clientWidth;
          l.style.opacity = "".concat(1 - p), l.style.transition = "0s", d.style.overflowY = "hidden", d.style.transform = "translateX(".concat(v, "px)"), d.style.transition = "0s", c.forEach(function (b) {
            var x;
            !b.current || (b.current.style.transform = "translateX(".concat(-1 * (1 - p) * A, "px)"), b.current.style.transition = "0s", ((x = b.current.parentElement) == null ? void 0 : x.style.display) === "none" && (b.current.parentElement.style.display = "block"));
          }), q = !1;
        }));
      }

      function h(_ref12) {
        var v = _ref12.swiped;
        requestAnimationFrame(function () {
          l.style.opacity = "".concat(v ? 0 : 1), l.style.transition = "var(--stackflow-transition-duration)", d.style.overflowY = "hidden", d.style.transform = "translateX(".concat(v ? "100%" : "0", ")"), d.style.transition = "var(--stackflow-transition-duration)", c.forEach(function (p) {
            !p.current || (p.current.style.transition = "var(--stackflow-transition-duration)", p.current.style.transform = "translateX(".concat(v ? "0" : "-".concat(A / 16, "rem"), ")"));
          }), T(d, "transitionend", function () {
            l.style.opacity = "", d.style.overflowY = "", d.style.transform = "", c.forEach(function (p, b) {
              if (!p.current) return;
              var x = g[b];
              v ? (p.current.style.transition = "", p.current.style.transform = "", p.current.parentElement && (p.current.parentElement.style.display = "")) : x && (p.current.style.transition = x.style.transition, p.current.style.transform = x.style.transform, p.current.parentElement && x.parentElement && (p.current.parentElement.style.display = x.parentElement.style.display));
            });
          });
        });
      }

      var I = function I(v) {
        var b;
        var _document = document,
            p = _document.activeElement;
        (b = p == null ? void 0 : p.blur) == null || b.call(p), f = u = v.touches[0].clientX, y = Date.now(), g = c.map(function (x) {
          return x.current ? {
            style: {
              transform: x.current.style.transform,
              transition: x.current.style.transition
            },
            parentElement: x.current.parentElement ? {
              style: {
                display: x.current.parentElement.style.display
              }
            } : void 0
          } : {
            style: {
              transform: "",
              transition: ""
            }
          };
        });
      },
          _ = function _(v) {
        if (!f) {
          m();
          return;
        }

        u = v.touches[0].clientX, z(u - f);
      },
          S = function S() {
        if (!f || !y || !u) {
          m();
          return;
        }

        var v = Date.now(),
            b = (u - f) / (v - y) > 1 || u / d.clientWidth > .4;
        b && (n == null || n()), m(), h({
          swiped: b
        });
      };

      return s.addEventListener("touchstart", I, {
        passive: !0
      }), s.addEventListener("touchmove", _, {
        passive: !0
      }), s.addEventListener("touchend", S, {
        passive: !0
      }), s.addEventListener("touchcancel", S, {
        passive: !0
      }), function () {
        s.removeEventListener("touchstart", I), s.removeEventListener("touchmove", _), s.removeEventListener("touchend", S), s.removeEventListener("touchcancel", S);
      };
    } : void 0
  });
}

import { useActions as at, useActivity as nt } from "@stackflow/react";
import { assignInlineVars as st } from "@vanilla-extract/dynamic";
import k, { useRef as it } from "react";
import fe from "react";

var tt = function tt(e) {
  return fe.createElement("svg", {
    className: e.className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, fe.createElement("path", {
    d: "M11.5659 5.56564C11.8783 5.25322 11.8783 4.74669 11.5659 4.43427C11.2535 4.12185 10.7469 4.12185 10.4345 4.43427L3.43451 11.4343C3.12209 11.7467 3.12209 12.2532 3.43451 12.5656L10.4345 19.5656C10.7469 19.8781 11.2535 19.8781 11.5659 19.5656C11.8783 19.2532 11.8783 18.7467 11.5659 18.4343L5.93157 12.8H20.0002C20.442 12.8 20.8002 12.4418 20.8002 12C20.8002 11.5581 20.442 11.2 20.0002 11.2H5.93157L11.5659 5.56564Z",
    fill: "currentColor"
  }));
},
    D = tt;

import $ from "react";

var rt = function rt(e) {
  return $.createElement("svg", {
    className: e.className,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, $.createElement("path", {
    d: "M6.56588 5.43433C6.25346 5.12191 5.74693 5.12191 5.43451 5.43433C5.12209 5.74675 5.12209 6.25328 5.43451 6.5657L10.8688 12L5.43451 17.4343C5.12209 17.7467 5.12209 18.2533 5.43451 18.5657C5.74693 18.8781 6.25346 18.8781 6.56588 18.5657L12.0002 13.1314L17.4345 18.5657C17.7469 18.8781 18.2535 18.8781 18.5659 18.5657C18.8783 18.2533 18.8783 17.7467 18.5659 17.4343L13.1316 12L18.5659 6.5657C18.8783 6.25328 18.8783 5.74675 18.5659 5.43433C18.2535 5.12191 17.7469 5.12191 17.4345 5.43433L12.0002 10.8686L6.56588 5.43433Z",
    fill: "currentColor"
  }), $.createElement("path", {
    d: "M6.56588 5.43433C6.25346 5.12191 5.74693 5.12191 5.43451 5.43433C5.12209 5.74675 5.12209 6.25328 5.43451 6.5657L10.8688 12L5.43451 17.4343C5.12209 17.7467 5.12209 18.2533 5.43451 18.5657C5.74693 18.8781 6.25346 18.8781 6.56588 18.5657L12.0002 13.1314L17.4345 18.5657C17.7469 18.8781 18.2535 18.8781 18.5659 18.5657C18.8783 18.2533 18.8783 17.7467 18.5659 17.4343L13.1316 12L18.5659 6.5657C18.8783 6.25328 18.8783 5.74675 18.5659 5.43433C18.2535 5.12191 17.7469 5.12191 17.4345 5.43433L12.0002 10.8686L6.56588 5.43433Z",
    fill: "currentColor"
  }));
},
    G = rt;

import { createRuntimeFn as ue } from "@vanilla-extract/recipes/createRuntimeFn";
var he = ue({
  defaultClassName: "_1yk3a450 dhthxq4 dhthxq8 dhthxq7 dhthxq0 dhthxqg _1dlf4347",
  variantClassNames: {
    border: {
      true: "_1yk3a451"
    }
  },
  defaultVariants: {},
  compoundVariants: []
}),
    W = "_1yk3a453 dhthxq8 dhthxq7 dhthxqa dhthxqe dhthxqh",
    xe = "_1yk3a455 dhthxq8 dhthxq7",
    ve = ue({
  defaultClassName: "_1yk3a456",
  variantClassNames: {
    hasLeft: {
      true: "_1yk3a457"
    }
  },
  defaultVariants: {},
  compoundVariants: []
}),
    ye = "_1yk3a458 dhthxqb dhthxqc dhthxq0",
    be = "_1yk3a453 dhthxq8 dhthxq7 dhthxqa dhthxqe dhthxqh",
    ge = "_1yk3a452 dhthxq8 dhthxq7 dhthxq1",
    Ce = "_1yk3a459 dhthxq8 dhthxq7 dhthxq1 dhthxq5";
import { createRuntimeFn as j } from "@vanilla-extract/recipes/createRuntimeFn";
var ke = j({
  defaultClassName: "dhthxq4 dhthxq0 dhthxq1 dhthxq2 dhthxq3 dhthxqb",
  variantClassNames: {
    transitionState: {
      "enter-active": "_1dlf4349",
      "enter-done": "_1dlf434a",
      "exit-active": "_1dlf434b",
      "exit-done": "_1dlf434c"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var Ee = "_1dlf434i dhthxq4 dhthxq0 dhthxq1 dhthxq2 dhthxq3 _1dlf4346 _1dlf4348",
    qe = j({
  defaultClassName: "_1dlf434l dhthxq4 dhthxq2 dhthxq3 dhthxq1",
  variantClassNames: {
    hasAppBar: {
      true: "_1dlf434m"
    }
  },
  defaultVariants: {},
  compoundVariants: []
});
var Re = j({
  defaultClassName: "_1dlf434j dhthxq4 dhthxq0 dhthxq1 dhthxq2 dhthxq3 _1dlf4347 _1dlf4348",
  variantClassNames: {
    hasAppBar: {
      true: "_1dlf434k dhthxqf"
    }
  },
  defaultVariants: {},
  compoundVariants: []
}),
    N = {
  transitionDuration: "var(--_1dlf4340)",
  zIndexes: {
    dim: "var(--_1dlf4341)",
    paper: "var(--_1dlf4342)",
    edge: "var(--_1dlf4343)",
    appBar: "var(--_1dlf4344)"
  },
  appBar: {
    center: {
      mainWidth: "var(--_1dlf4345)"
    }
  }
};
var ct = k.forwardRef(function (_ref13, g) {
  var _R2;

  var e = _ref13.title,
      o = _ref13.appendLeft,
      r = _ref13.appendRight,
      t = _ref13.backButton,
      a = _ref13.closeButton,
      _ref13$closeButtonLoc = _ref13.closeButtonLocation,
      n = _ref13$closeButtonLoc === void 0 ? "left" : _ref13$closeButtonLoc,
      _ref13$border = _ref13.border,
      c = _ref13$border === void 0 ? !0 : _ref13$border,
      l = _ref13.iconColor,
      s = _ref13.textColor,
      d = _ref13.borderColor,
      f = _ref13.borderSize,
      y = _ref13.height,
      u = _ref13.backgroundColor;
  var J;

  var m = at(),
      q = nt(),
      z = V(),
      h = (J = z.appBar) == null ? void 0 : J.closeButton,
      I = it(null),
      _ce = ce({
    outerRef: g,
    innerRef: I,
    enable: z.theme === "cupertino"
  }),
      _ = _ce.maxWidth,
      S = function S(E) {
    t && "onClick" in t && t.onClick && t.onClick(E), E.defaultPrevented || m.pop();
  },
      v = q.zIndex === 0 || q.zIndex === 1 && q.transitionState === "enter-active" && q.pushedBy.name === "Replaced",
      p = function p() {
    var E;
    return v ? null : t ? "render" in t && t.render ? (E = t.render) == null ? void 0 : E.call(t) : k.createElement("button", {
      type: "button",
      className: W,
      onClick: S
    }, "renderIcon" in t && t.renderIcon ? t.renderIcon() : k.createElement(D, null)) : k.createElement("button", {
      type: "button",
      className: W,
      onClick: S
    }, k.createElement(D, null));
  },
      b = function b(E) {
    var K;
    a && "onClick" in a && a.onClick && a.onClick(E), !E.defaultPrevented && h && "onClick" in h && ((K = h.onClick) == null || K.call(h, E));
  },
      x = function x() {
    var E;
    return !a && !((E = z.appBar) != null && E.closeButton) || !v ? null : a && "render" in a && a.render ? a.render() : h && "render" in h && h.render ? h.render() : k.createElement("button", {
      type: "button",
      className: be,
      onClick: b
    }, function () {
      return a && "renderIcon" in a && a.renderIcon ? a.renderIcon() : h && "renderIcon" in h && h.renderIcon ? h.renderIcon() : k.createElement(G, null);
    }());
  },
      Pe = !!(n === "left" && a || t || o);

  return k.createElement("div", {
    ref: g,
    className: he({
      border: c
    }),
    style: st(R((_R2 = {}, _defineProperty(_R2, i.appBar.iconColor, l), _defineProperty(_R2, i.appBar.textColor, s), _defineProperty(_R2, i.appBar.borderColor, d), _defineProperty(_R2, i.appBar.borderSize, f), _defineProperty(_R2, i.appBar.height, y), _defineProperty(_R2, i.appBar.backgroundColor, u || i.backgroundColor), _defineProperty(_R2, N.appBar.center.mainWidth, "".concat(_, "px")), _R2)))
  }, k.createElement("div", {
    className: ge
  }, n === "left" && x(), p(), o == null ? void 0 : o()), k.createElement("div", {
    ref: I,
    className: xe
  }, k.createElement("div", {
    className: ve({
      hasLeft: Pe
    })
  }, typeof e == "string" ? k.createElement("div", {
    className: ye
  }, e) : e)), k.createElement("div", {
    className: Ce
  }, r == null ? void 0 : r(), n === "right" && x()));
}),
    Se = ct;

var mt = function mt(_ref14) {
  var _R3;

  var e = _ref14.backgroundColor,
      o = _ref14.dimBackgroundColor,
      r = _ref14.appBar,
      t = _ref14.children;

  var a = V(),
      n = dt(),
      _lt = lt(),
      c = _lt.pop,
      l = P(null),
      s = P(null),
      d = P(null),
      f = P(null),
      y = P(null);

  de({
    refs: [l],
    hasEffect: !0
  }), pe({
    theme: a.theme,
    refs: a.theme === "cupertino" ? [d] : [d, y],
    hasEffect: !0
  }), me({
    theme: a.theme,
    dimRef: s,
    edgeRef: f,
    paperRef: d,
    hasEffect: !0,
    onSwiped: function onSwiped() {
      c();
    }
  });
  var u = n.zIndex === 0,
      g = !!r,
      m = n.zIndex * 5,
      q = m,
      z = m + (a.theme === "cupertino" && g ? 1 : 3),
      h = m + 4,
      I = m + 7,
      _ = n.transitionState,
      S = L(_);
  return w.createElement("div", {
    ref: l,
    className: ke({
      transitionState: _ === "enter-done" || _ === "exit-done" ? _ : S
    }),
    style: pt(R((_R3 = {}, _defineProperty(_R3, i.backgroundColor, e), _defineProperty(_R3, i.dimBackgroundColor, o), _defineProperty(_R3, i.appBar.height, r == null ? void 0 : r.height), _defineProperty(_R3, N.zIndexes.dim, "".concat(q)), _defineProperty(_R3, N.zIndexes.paper, "".concat(z)), _defineProperty(_R3, N.zIndexes.edge, "".concat(h)), _defineProperty(_R3, N.zIndexes.appBar, "".concat(I)), _defineProperty(_R3, N.transitionDuration, n.transitionState === "enter-active" || n.transitionState === "exit-active" ? "var(--stackflow-transition-duration)" : "0ms"), _R3)))
  }, w.createElement("div", {
    className: Ee,
    ref: s
  }), w.createElement("div", {
    key: n.id,
    className: Re({
      hasAppBar: g
    }),
    ref: d
  }, t), !u && a.theme === "cupertino" && w.createElement("div", {
    className: qe({
      hasAppBar: g
    }),
    ref: f
  }), r && w.createElement(Se, oe(re({}, r), {
    ref: y
  })));
},
    ft = mt;

import { useActions as xt, useActivity as vt } from "@stackflow/react";
import { assignInlineVars as yt } from "@vanilla-extract/dynamic";
import X, { useRef as U } from "react";
import { createRuntimeFn as ut } from "@vanilla-extract/recipes/createRuntimeFn";
var Ne = ut({
  defaultClassName: "dhthxq4 dhthxq0 dhthxq1 dhthxq2 dhthxq3 dhthxqb",
  variantClassNames: {
    transitionState: {
      "enter-active": "_1ht38h04",
      "enter-done": "_1ht38h05",
      "exit-active": "_1ht38h06",
      "exit-done": "_1ht38h07"
    }
  },
  defaultVariants: {},
  compoundVariants: []
}),
    ze = "_1ht38h0d dhthxq4 dhthxq0 dhthxq1 dhthxq2 dhthxq3 dhthxqb dhthxq9 dhthxq7 _1ht38h03";
var Ie = "_1ht38h0e dhthxqb _1ht38h03",
    H = {
  transitionDuration: "var(--_1ht38h00)",
  zIndexes: {
    dim: "var(--_1ht38h01)",
    paper: "var(--_1ht38h02)"
  }
};

var bt = function bt(_ref15) {
  var _R4;

  var _ref15$borderRadius = _ref15.borderRadius,
      e = _ref15$borderRadius === void 0 ? "1rem" : _ref15$borderRadius,
      o = _ref15.backgroundColor,
      r = _ref15.dimBackgroundColor,
      t = _ref15.onOutsideClick,
      a = _ref15.children;

  var n = vt(),
      _xt = xt(),
      c = _xt.pop,
      l = U(null),
      s = U(null);

  C({
    styleName: "hide",
    refs: [l]
  }), C({
    styleName: "offset",
    refs: [s]
  }), C({
    styleName: "swipe-back",
    refs: [s]
  });

  var d = U(!1),
      f = function f(m) {
    t == null || t(m), !m.defaultPrevented && (d.current || (d.current = !0, c()));
  },
      y = function y(m) {
    m.stopPropagation();
  },
      u = n.zIndex * 5 + 3,
      g = n.zIndex * 5 + 4;

  return X.createElement("div", {
    className: Ne({
      transitionState: L(n.transitionState)
    }),
    ref: l,
    style: yt(R((_R4 = {}, _defineProperty(_R4, i.bottomSheet.borderRadius, e), _defineProperty(_R4, i.backgroundColor, o), _defineProperty(_R4, i.dimBackgroundColor, r), _defineProperty(_R4, H.zIndexes.dim, "".concat(u)), _defineProperty(_R4, H.zIndexes.paper, "".concat(g)), _defineProperty(_R4, H.transitionDuration, n.transitionState === "enter-active" || n.transitionState === "exit-active" ? "var(--stackflow-transition-duration)" : "0ms"), _R4)))
  }, X.createElement("div", {
    className: ze,
    ref: s,
    onClick: f
  }, X.createElement("div", {
    className: Ie,
    onClick: y
  }, a)));
},
    gt = bt;

import { useActions as Et, useActivity as qt } from "@stackflow/react";
import { assignInlineVars as Rt } from "@vanilla-extract/dynamic";
import Y, { useRef as Z } from "react";
import { createRuntimeFn as Ct } from "@vanilla-extract/recipes/createRuntimeFn";
var Le = Ct({
  defaultClassName: "dhthxq4 dhthxq0 dhthxq1 dhthxq2 dhthxq3 dhthxqb",
  variantClassNames: {
    transitionState: {
      "enter-active": "_5ozg8c4",
      "enter-done": "_5ozg8c5",
      "exit-active": "_5ozg8c6",
      "exit-done": "_5ozg8c7"
    }
  },
  defaultVariants: {},
  compoundVariants: []
}),
    Me = "_5ozg8cd dhthxq4 dhthxq0 dhthxq1 dhthxq2 dhthxq3 dhthxqb dhthxq8 dhthxq7 dhthxqa _5ozg8c3";
var we = "_5ozg8ce dhthxqb _5ozg8c3",
    O = {
  transitionDuration: "var(--_5ozg8c0)",
  zIndexes: {
    dim: "var(--_5ozg8c1)",
    paper: "var(--_5ozg8c2)"
  }
};

var _t = function _t(_ref16) {
  var _R5;

  var e = _ref16.backgroundColor,
      o = _ref16.dimBackgroundColor,
      _ref16$borderRadius = _ref16.borderRadius,
      r = _ref16$borderRadius === void 0 ? "1rem" : _ref16$borderRadius,
      t = _ref16.onOutsideClick,
      a = _ref16.children;

  var n = qt(),
      _Et = Et(),
      c = _Et.pop,
      l = Z(null),
      s = Z(null);

  C({
    styleName: "hide",
    refs: [l]
  }), C({
    styleName: "offset",
    refs: [s]
  }), C({
    styleName: "swipe-back",
    refs: [s]
  });

  var d = Z(!1),
      f = function f(m) {
    t == null || t(m), !m.defaultPrevented && (d.current || (d.current = !0, c()));
  },
      y = function y(m) {
    m.stopPropagation();
  },
      u = n.zIndex * 5 + 3,
      g = n.zIndex * 5 + 4;

  return Y.createElement("div", {
    className: Le({
      transitionState: L(n.transitionState)
    }),
    ref: l,
    style: Rt(R((_R5 = {}, _defineProperty(_R5, i.bottomSheet.borderRadius, r), _defineProperty(_R5, i.backgroundColor, e), _defineProperty(_R5, i.dimBackgroundColor, o), _defineProperty(_R5, O.zIndexes.dim, "".concat(u)), _defineProperty(_R5, O.zIndexes.paper, "".concat(g)), _defineProperty(_R5, O.transitionDuration, n.transitionState === "enter-active" || n.transitionState === "exit-active" ? "var(--stackflow-transition-duration)" : "0ms"), _R5)))
  }, Y.createElement("div", {
    className: Me,
    ref: s,
    onClick: f
  }, Y.createElement("div", {
    className: we,
    onClick: y
  }, a)));
},
    St = _t;

export { ft as AppScreen, gt as BottomSheet, St as Modal, Ue as basicUIPlugin, i as cssVars };